export interface ResetExternalCollaborationRequest {
  externalId: string
}

export function ResetExternalCollaborationRequestToJSON(
  value: ResetExternalCollaborationRequest
): any {
  return {
    external_id: value.externalId !== '' ? value.externalId : undefined
  }
}
